<nz-select
  *ngIf="!hideSelector"
  #selectRef
  class="ui-multli-select-list"
  [ngModel]="selectedValueList"
  (ngModelChange)="onValueChange($event)"
  (nzOpenChange)="onSelectOpened($event)"
  (nzBlur)="onTouched()"
  (nzFocus)="onTouched()"
  [nzDisabled]="disabled"
  [nzPlaceHolder]="placeholder ?? ''"
  [nzAllowClear]="false"
  nzMode="multiple"
  [nzShowSearch]="showSearch"
  [nzServerSearch]="serverSearch"
  (nzOnSearch)="onSearch($event)"
  (nzScrollToBottom)="loadMore()"
  nzDropdownClassName="ui-multli-select-list-dropdown"
  [nzOptionHeightPx]="48"
  [compareWith]="compareFn"
  [nzPlacement]="'topRight'"
>
  @if (!isLoadingData) { @for (option of options; track (optionValueField ?
  option[optionValueField] : option)) {
  <nz-option
    [nzLabel]="option | getFieldValue : optionLabelField | localization"
    [nzValue]="option"
    [nzHide]="isSelected(option)"
  ></nz-option>
  } } @else {
  <nz-option nzDisabled nzCustomContent>
    <ui-loading size="16px" text="Загрузка данных..."></ui-loading>
  </nz-option>
  }
</nz-select>

<ng-template #renderTemplate>
  @if (isLoadingMore) {
  <ui-loading></ui-loading>
  }
</ng-template>

<div
  class="selected-value-list"
  [ngStyle]="{ 'margin-top': hideSelector ? '0' : '16px' }"
>
  @if((selectedValueList??[]).length ===0){
  <div class="selected-value" [ngClass]="{ disabled: true }">
    {{ 'Пусто' }}
  </div>
  } @for (selectedValue of selectedValueList; track $index) {
  <div
    class="selected-value"
    (click)="onRemoveSelectedValue($index)"
    aria-hidden="true"
    [ngClass]="{ disabled: disabled }"
  >
    {{ selectedValue | getFieldValue : optionLabelField }}
  </div>
  }
</div>
